export enum MilestoneLogCode {
  courseStarted = 101,
  participationCertificate = 201,
  testCertificate = 301,
  courseFavorited = 401,
}

export type Milestone = {
  courseId: number;
  id: number;
  logCode: MilestoneLogCode;
  logDate: string;
  personId: number;
};
